'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PrimarySummaryEditor = require('./components/PrimarySummaryEditor');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PrimarySummaryEditor).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/shared/ugc-editors/lib/components/primary-summary-editor/index.js
// module id = 1039
// module chunks = 4